import { Component, inject } from '@angular/core';

import { LayoutService } from '#core/services/layout.service';

@Component({
  selector: 'di-layout',
  templateUrl: './layout.component.html',
  standalone: false,
  host: {
    class: 'tw:flex tw:flex-col tw:flex-1 tw:h-full tw:px-5',
  },
})
export class LayoutComponent {
  private layoutService = inject(LayoutService);

  constructor() {
    this.layoutService.trackRouterChanges();
  }
}
